import React from 'react';
import { useSelector } from 'react-redux';

import { commentReact, commentReactionDelete } from "state/detailedposting/actions";
import { getCommentsReceiverPostingId } from "state/detailedposting/selectors";
import { useDispatcher } from "ui/hook";
import { ReactionButton } from "ui/control";
import { MaterialSymbol } from "ui/material-symbols";
import "./CommentButton.css";

interface Props {
    icon: MaterialSymbol;
    caption: string;
    invisible: boolean;
    id: string;
    negative: boolean;
    emoji: number | null;
    rejected?: string | null;
}

export default function CommentReactionButton({icon, caption, invisible, id, negative, emoji, rejected}: Props) {
    const postingId = useSelector(getCommentsReceiverPostingId);
    const dispatch = useDispatcher();

    if (postingId == null) {
        return null;
    }

    const onReactionAdd = (negative: boolean, emoji: number) => dispatch(commentReact(id, negative, emoji));
    const onReactionDelete = () => dispatch(commentReactionDelete(id, postingId));

    return (
        <ReactionButton
            icon={icon}
            emoji={emoji}
            caption={caption}
            className="comment-button"
            negative={negative}
            rejected={rejected}
            invisible={invisible}
            onReactionAdd={onReactionAdd}
            onReactionDelete={onReactionDelete}
        />
    );
}
